module.exports = __webpack_public_path__ + "static/video-829c4b3ad229dbb32270925b8785620b.mp4";